'use client';
import { usePathname } from 'next/navigation';
import { Button } from '../components/_catalyst/button';

export default function NotFound() {
  const pathname = usePathname();
  const lng = pathname.split('/')[1] || 'en';
  return (
    <div className="bg-cPrimary flex h-screen w-screen flex-col items-center justify-center">
      <p className="text-2xl text-white">Oh no!</p>
      <p className="my-4 text-white">Could not find requested resource</p>
      <Button href={`/${lng}/dashboard`}>Home</Button>
    </div>
  );
}
